<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">DADOS COMPLEMENTARES</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6">
      <div v-if="this.provider.employer_number.length >= 14">
        <v-row v-if="$route.query.user_gfs_token || form.cnaes.length > 0">
          <v-col cols="8">
            <BaseInputValidation
              disabled
              id="cnae"
              name="CNAE Principal *"
              rules="required"
              v-model="form.cnae"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="auto">
            <v-btn
              @click="getDataReceita"
              block
              x-large
              :loading="loadingReceita"
              :disabled="view"
              v-if="$route.query.user_gfs_token"
            >
              <v-icon left dark> mdi-refresh </v-icon>
              Sincronizar dados
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="form.cnaes.length > 0">
        <v-col cols="12">
          <h2 style="font-weight: 300">CNAEs Secundários</h2>
        </v-col>
        <v-col cols="10">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in form.cnaes" :key="item.code">
                  <td v-if="item.main == 0">{{ item.description }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" v-if="this.provider.employer_number.length >= 14">
          <label for="row">Optante do simples nacional * </label>
          <validation-provider
            :disabled="view"
            v-slot="{ errors }"
            rules="required"
            name="Optante do Simples Nacional?"
          >
            <v-radio-group
              v-model="form.national_simple_optant"
              row
              :error-messages="errors"
            >
              <v-radio :disabled="view" label="SIM" :value="1"></v-radio>
              <v-radio :disabled="view" label="NÃO" :value="0"></v-radio>
            </v-radio-group>
          </validation-provider>
        </v-col>

        <v-col cols="4" v-else>
          <label for="row">Optante do simples nacional</label>
          <validation-provider
            :disabled="view"
            v-slot="{ errors }"
            name="Optante do Simples Nacional?"
          >
            <v-radio-group
              v-model="form.national_simple_optant"
              row
              :error-messages="errors"
            >
              <v-radio :disabled="view" label="SIM" :value="1"></v-radio>
              <v-radio :disabled="view" label="NÃO" :value="0"></v-radio>
            </v-radio-group>
          </validation-provider>
        </v-col>

        <v-col cols="4" v-if="this.provider.employer_number.length <= 11">
          <BaseInputValidation
            v-mask="['###.#####.##-#']"
            id="taxpayer_number"
            name="Número do Contribuinte *"
            rules="required"
            v-model="form.taxpayer_number"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="4" v-else>
          <BaseInputValidation
            v-mask="['###.#####.##-#']"
            id="taxpayer_number"
            name="Número do Contribuinte"
            v-model="form.taxpayer_number"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <BaseInputValidation
            id="autonomous_category"
            name="Categoria do Autônomo"
            v-model="form.autonomous_category"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="4">
          <BaseInputValidation
            id="autonomous_cbo"
            name="CBO Autônomo"
            v-model="form.autonomous_cbo"
            rules="max:255"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" v-if="this.provider.employer_number.length >= 14">
          <validation-provider
            v-slot="{ errors }"
            name="Regime de ISS"
            rules="required"
          >
            <v-autocomplete
              v-model="form.regime_iss_id"
              :items="iss"
              item-text="code_description"
              item-value="id"
              outlined
              :error-messages="errors"
              label="Regime de ISS *"
              :disabled="view"
            ></v-autocomplete>
          </validation-provider>
        </v-col>
        <v-col cols="4" v-else>
          <validation-provider v-slot="{ errors }" name="Regime de ISS">
            <v-autocomplete
              v-model="form.regime_iss_id"
              :items="iss"
              item-text="code_description"
              item-value="id"
              outlined
              :error-messages="errors"
              label="Regime de ISS"
              :disabled="view"
            ></v-autocomplete>
          </validation-provider>
        </v-col>
        <v-col cols="4">
          <validation-provider v-slot="{ errors }" name="Código da Receita">
            <v-autocomplete
              v-model="form.recipe_code_id"
              :items="recipeCode"
              item-text="code_description"
              item-value="id"
              outlined
              :error-messages="errors"
              label="Código da Receita "
              :disabled="view"
            ></v-autocomplete>
          </validation-provider>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import BaseInputValidation from "../../../../components/UI/BaseInputValidation";
import { ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

// import cloneDeep from "lodash/cloneDeep";

export default {
  props: { view: { type: Boolean, default: false } },
  directives: { mask },
  data: () => ({
    loadingReceita: false,
    form: {
      cnae: "",
      cnaes: [],
      national_simple: false,
      national_simple_optant: "",
      taxpayer_number: "",
      autonomous_category: "",
      autonomous_cbo: "",
      regime_iss_id: "",
      recipe_code_id: ""
    }
  }),
  computed: {
    ...mapGetters({
      providerReceita: "$_provider/providerReceita",
      provider: "$_provider/provider",
      iss: "$_provider/iss",
      recipeCode: "$_provider/recipeCode"
    })
  },
  components: {
    ValidationProvider,
    BaseInputValidation
  },

  async created() {
    await Promise.all([
      this.getRecipeCode({ limit: -1 }),
      this.getIss({ limit: -1 })
    ]);
  },

  async mounted() {
    Object.entries(this.form).forEach(element => {
      this.form[element[0]] = this.provider[element[0]];
    });
    this.form.cnaes.forEach(element => {
      if (element.main == true) this.form.cnae = element.description;
    });
    this.form.national_simple_optant = isNaN(
      parseInt(this.form.national_simple_optant)
    )
      ? null
      : parseInt(this.form.national_simple_optant);
    this.form.regime_iss_id = parseInt(this.form.regime_iss_id) || null;
    this.form.recipe_code_id = parseInt(this.form.recipe_code_id) || null;
  },

  watch: {
    form: {
      handler: function(newVal) {
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    }
  },

  methods: {
    async getDataReceita() {
      this.loadingReceita = true;
      try {
        await this.getReceitaData(this.provider.employer_number);
        this.form.cnaes = [];
        this.providerReceita.atividades_secundarias.forEach(element => {
          let cnae = {
            description: element.text,
            code: element.code,
            main: false
          };
          this.form.cnaes.push(cnae);
        });
        this.providerReceita.atividade_principal.forEach(element => {
          let cnae = {
            description: element.text,
            code: element.code,
            main: true
          };
          this.form.cnae = element.text;
          this.form.cnaes.push(cnae);
        });
        this.$emit("setCnaes", {
          data: this.form.cnaes
        });
        this.loadingReceita = false;
      } catch (error) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message:
            "Houve um problema com a comunicação do webservice da receita federal aguarde pelo menos 2 minutos para fazer novamente.",
          type: "warning",
          title: "Sucesso!",
          timeout: 8000
        });
        this.loadingReceita = false;
      }
    },

    ...mapActions({
      getReceitaData: "$_provider/getReceitaInfo",
      getRecipeCode: "$_provider/getRecipeCode",
      getIss: "$_provider/getIss"
    })
  }
};
</script>

<style lang="scss">
tbody {
  tr:nth-child(odd) {
    background: #d8d8d8;
  }
  tr:nth-child(even) {
    background: #edeeee;
  }
}
</style>
